import React from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Grid,
  Box,
} from "@material-ui/core/";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
    fontWeight: 600,
    fontSize: 13,
  },
  body: {
    fontSize: 13,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    padding: theme.spacing(3),
    maxWidth: 1200,
    margin: "0 auto",
  },
  sectionPaper: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
    fontWeight: 700,
    fontSize: "1.8rem",
  },
  summaryRow: {
    marginBottom: theme.spacing(1.5),
  },
  summaryLabel: {
    fontWeight: 600,
    fontSize: "0.95rem",
  },
  summaryText: {
    fontSize: "0.95rem",
  },
  tableTitle: {
    margin: theme.spacing(2, 0, 1, 0),
    fontWeight: 600,
    fontSize: "1rem",
  },
  totalRow: {
    fontWeight: 700,
  },
  amountCell: {
    textAlign: "right",
  },
}));

const giftAidData = [
  {
    fundName: "Federal Pell Grant",
    fall: "$2,000.00",
    spring: "$2,000.00",
    totalOffered: "$4,000.00",
    totalAccepted: "$4,000.00",
    status: "Accepted",
  },
  {
    fundName: "Presidential Scholarship",
    fall: "$1,500.00",
    spring: "$1,500.00",
    totalOffered: "$3,000.00",
    totalAccepted: "$3,000.00",
    status: "Accepted",
  },
];

const loanData = [
  {
    fundName: "Direct Unsubsidized Loan",
    fall: "$4,500.00",
    spring: "$4,500.00",
    totalOffered: "$20,000.00",
    totalAccepted: "$9,000.00",
    status: "Accepted",
  },
  {
    fundName: "Private Loan",
    fall: "$2,000.00",
    spring: "$2,000.00",
    totalOffered: "$4,000.00",
    totalAccepted: "$4,000.00",
    status: "Accepted",
  },
];

const FinancialAidPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.pageContainer}>
      <Typography variant="h4" className={classes.sectionTitle}>
        Financial Aid Summary
      </Typography>

      <Paper className={classes.sectionPaper} elevation={1}>
        <Box mb={2}>
          <Typography variant="h6" className={classes.summaryLabel}>
            Satisfactory Academic Progress (SAP):
          </Typography>
          <Typography className={classes.summaryText}>Making Satisfactory Progress</Typography>
        </Box>

        <Box mb={2}>
          <Typography variant="h6" className={classes.summaryLabel}>
            Summary - Federal Aid Year 2025-2026
          </Typography>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} className={classes.summaryRow}>
              <Box>
              <Typography className={classes.summaryLabel} display="inline">
                Estimated Cost of Attendance:
              </Typography>{" "}
              <Typography className={classes.summaryText} display="inline">$30,560.00</Typography></Box>
              <Box>
               <Typography className={classes.summaryLabel} display="inline">
                Expected Family Contribution:
              </Typography>{" "}
              <Typography className={classes.summaryText} display="inline">$5,350.00</Typography></Box>
            </Grid>
            
          </Grid>
        </Box>

        <Typography variant="subtitle1" className={classes.tableTitle}>
          Gift Aid
        </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>Fund Name</StyledTableCell>
                <StyledTableCell align="right">Fall 2025</StyledTableCell>
                <StyledTableCell align="right">Spring 2026</StyledTableCell>
                <StyledTableCell align="right">Total Offered</StyledTableCell>
                <StyledTableCell align="right">Total Accepted</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {giftAidData.map((row, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell component="th" scope="row">
                    {row.fundName}
                  </StyledTableCell>
                  <StyledTableCell align="right">{row.fall}</StyledTableCell>
                  <StyledTableCell align="right">{row.spring}</StyledTableCell>
                  <StyledTableCell align="right">{row.totalOffered}</StyledTableCell>
                  <StyledTableCell align="right">{row.totalAccepted}</StyledTableCell>
                  <StyledTableCell>{row.status}</StyledTableCell>
                </StyledTableRow>
              ))}
              <StyledTableRow>
                <StyledTableCell className={classes.totalRow}>Total</StyledTableCell>
                <StyledTableCell align="right" className={classes.totalRow}>
                  $3,500.00
                </StyledTableCell>
                <StyledTableCell align="right" className={classes.totalRow}>
                  $3,500.00
                </StyledTableCell>
                <StyledTableCell align="right" className={classes.totalRow}>
                  $7,000.00
                </StyledTableCell>
                <StyledTableCell align="right" className={classes.totalRow}>
                  $7,000.00
                </StyledTableCell>
                <StyledTableCell />
              </StyledTableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Typography variant="subtitle1" className={classes.tableTitle}>
          Loans
        </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>Fund Name</StyledTableCell>
                <StyledTableCell align="right">Fall 2025</StyledTableCell>
                <StyledTableCell align="right">Spring 2026</StyledTableCell>
                <StyledTableCell align="right">Total Offered</StyledTableCell>
                <StyledTableCell align="right">Total Accepted</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loanData.map((row, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell component="th" scope="row">
                    {row.fundName}
                  </StyledTableCell>
                  <StyledTableCell align="right">{row.fall}</StyledTableCell>
                  <StyledTableCell align="right">{row.spring}</StyledTableCell>
                  <StyledTableCell align="right">{row.totalOffered}</StyledTableCell>
                  <StyledTableCell align="right">{row.totalAccepted}</StyledTableCell>
                  <StyledTableCell>{row.status}</StyledTableCell>
                </StyledTableRow>
              ))}
              <StyledTableRow>
                <StyledTableCell className={classes.totalRow}>Total</StyledTableCell>
                <StyledTableCell align="right" className={classes.totalRow}>
                  $6,500.00
                </StyledTableCell>
                <StyledTableCell align="right" className={classes.totalRow}>
                  $6,500.00
                </StyledTableCell>
                <StyledTableCell align="right" className={classes.totalRow}>
                  $24,000.00
                </StyledTableCell>
                <StyledTableCell align="right" className={classes.totalRow}>
                  $13,000.00
                </StyledTableCell>
                <StyledTableCell />
              </StyledTableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Box mt={2}>
          <Typography className={classes.summaryLabel}>
            Award Package Total
          </Typography>
          <Typography>$20,000.00</Typography>
        </Box>
      </Paper>
    </div>
  );
};

export default FinancialAidPage;
